import { useEffect, useState } from "react";
import Button from "src/components/Button";
import Layout from "src/components/layout/Layout";
import useSubscription from "src/hooks/selectors/useSubscription";
import ProfileTabs from "src/views/authenticated/profile/ProfileTabs";
import useUsers from "src/hooks/api/services/users/useUsers";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useAuth from "src/hooks/selectors/useAuth";
import useWindowSize from "src/hooks/useWindowSize";
import UserList from "src/components/team/users/UserList";
import Tabs from "src/components/layout/Tabs";
import Tab from "src/components/layout/Tab";
import useTeams from "src/hooks/api/services/users/useTeams";
import useQueryString from "src/hooks/useQueryString";

function UsersView({ t }: Translation) {
	const auth = useAuth();
	const { users, actions } = useUsers();
	const { teams } = useTeams();
	const qs = useQueryString();
	const [selectedTeam, setSelectedTeam] = useState<any>(
		qs?.team?.toString() || undefined
	);
	const subscription = useSubscription();
	const { isPhone } = useWindowSize();
	const usersCount = users?.length;
	const allowedUsers = subscription?.plan?.users || undefined;

	useEffect(() => {
		actions.list();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Layout title={t("title")}>
			<ProfileTabs />

			<div className="flex justify-between">
				<p className="mt-4 mb-0">
					{t("total", {
						count: usersCount,
						total: allowedUsers || 1,
					})}
				</p>

				{(subscription?.id || auth.mode === "demo") && (
					<>
						<div className="flex items-center gap-4">
							<Button
								type="dark"
								to={{
									modal: "/profile/users/invite",
								}}
								iconOnly={isPhone}
							>
								<i className="fas fa-user-plus md:mr-2"></i>
								{!isPhone && (
									<span>{t("buttons.invite-user")}</span>
								)}
							</Button>
							{/* <Button
								type="dark"
								to={{
									modal: "/profile/teams/create",
								}}
								iconOnly={isPhone}
							>
								<i className="fas fa-users-medical md:mr-2"></i>
								{!isPhone && (
									<span>{t("buttons.create-team")}</span>
								)}
							</Button> */}
						</div>
					</>
				)}
			</div>
			<div
				className={`flex flex-col gap-4 flex-1 overflow-auto hide-scrollbar md:mx-0 md:px-0 -mx-4 px-4`}
			>
				<Tabs.Container>
					<Tab
						active={selectedTeam === undefined}
						onClick={() => setSelectedTeam(undefined)}
					>
						{t("tabs.all")}
					</Tab>
					{teams.map((team) => (
						<Tab
							key={`tab-${team.slug}`}
							active={selectedTeam === team.slug}
							onClick={() => setSelectedTeam(team.slug)}
						>
							{team.name}
						</Tab>
					))}
				</Tabs.Container>

				<UserList {...{ selectedTeam }} />
			</div>
		</Layout>
	);
}

UsersView.locale = {
	nl: {
		tabs: {
			all: "Alle leden",
		},
		title: "Gebruikers",
		total: "{{count}} / {{total}} licensies gebruikt",
		create: "Gebruiker toevoegen",
		empty: "Op dit moment zijn er geen gebruikers die bij dit account horen",
		invite: {
			pending: "Afwachting van reactie",
			telephone: "Telefoonnummer",
			email: "Email",
		},
		buttons: {
			"create-team": "Team aanmaken",
			"invite-user": "Teamleden uitnodigen",
		},
	},
	en: {
		tabs: {
			all: "All members",
		},
		title: "Users",
		total: "{{count}} / {{total}} licenses used",
		create: "Add user",
		empty: "There are no users currently associated with this account",
		invite: {
			pending: "Waiting for response",
			telephone: "Telephone number",
			email: "Email",
		},
		buttons: {
			"create-team": "Create team",
			"invite-user": "Invite team",
		},
	},
};

export default withTranslation(UsersView);
